import React from 'react';
import Icon from '../../../components/AppIcon';

const TechnicianPerformanceTable = ({ data = [], loading = false }) => {
  const formatCurrency = (value) => {
    return `$${value?.toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-elevation-1 p-4 md:p-6">
      <div className="flex items-center gap-2 mb-4 md:mb-6">
        <Icon name="Award" size={24} className="text-warning" />
        <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
          Desempeño por Técnico
        </h2>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-32">
          <Icon name="Loader2" className="w-8 h-8 text-blue-600 animate-spin" />
        </div>
      ) : data?.length === 0 ? (
        <div className="flex flex-col items-center justify-center h-32">
          <Icon name="UserX" size={48} className="text-muted-foreground mb-2" />
          <p className="text-sm caption text-muted-foreground">
            No hay datos de desempeño disponibles
          </p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-border">
                <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">
                  Ranking
                </th>
                <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">
                  Técnico
                </th>
                <th className="text-right py-3 px-4 text-sm font-semibold text-foreground">
                  Ingresos Totales
                </th>
                <th className="text-right py-3 px-4 text-sm font-semibold text-foreground">
                  Órdenes Completadas
                </th>
                <th className="text-right py-3 px-4 text-sm font-semibold text-foreground">
                  Ticket Promedio
                </th>
              </tr>
            </thead>
            <tbody>
              {data?.map((tech, index) => (
                <tr 
                  key={tech?.technicianId} 
                  className="border-b border-border hover:bg-muted/50 transition-smooth"
                >
                  <td className="py-3 px-4">
                    <div className="flex items-center gap-2">
                      {index === 0 && (
                        <Icon name="Trophy" size={20} className="text-warning" />
                      )}
                      <span className="text-sm font-medium text-foreground">
                        #{index + 1}
                      </span>
                    </div>
                  </td>
                  <td className="py-3 px-4">
                    <span className="text-sm text-foreground">
                      {tech?.technicianName}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-right">
                    <span className="text-sm font-semibold text-success">
                      {formatCurrency(tech?.totalRevenue)}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-right">
                    <span className="text-sm text-foreground">
                      {tech?.completedOrders}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-right">
                    <span className="text-sm text-foreground">
                      {formatCurrency(tech?.averageTicket)}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default TechnicianPerformanceTable;